import { render } from "./1BeforeYouTravel.vue?vue&type=template&id=5ec95d83"
import script from "./1BeforeYouTravel.vue?vue&type=script&lang=js"
export * from "./1BeforeYouTravel.vue?vue&type=script&lang=js"

import "./1BeforeYouTravel.vue?vue&type=style&index=0&id=5ec95d83&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__